import { render, staticRenderFns } from "./allCompaniesComponent.vue?vue&type=template&id=7354d83e&"
import script from "./allCompaniesComponent.vue?vue&type=script&lang=js&"
export * from "./allCompaniesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports